import { z } from 'zod';
export const DocumentCategorySchema = z.enum([
    'DEMANDA',
    'CONTESTACION',
    'RECURSO',
    'SENTENCIA',
    'NOTIFICACION_JUZGADO',
    'PRUEBA',
    'CONTRATO',
    'BORRADOR',
    'CORREO',
    'IDENTIFICACION',
    'OTRO',
]);
export const DocumentCategoryLabel = {
    DEMANDA: 'Demanda',
    CONTESTACION: 'Contestación',
    RECURSO: 'Recurso',
    SENTENCIA: 'Sentencia',
    NOTIFICACION_JUZGADO: 'Notificación juzgado',
    PRUEBA: 'Prueba',
    CONTRATO: 'Contrato',
    BORRADOR: 'Borrador',
    CORREO: 'Correo',
    IDENTIFICACION: 'Identificación',
    OTRO: 'Otro',
};
export const DocumentVersionDtoSchema = z.object({
    id: z.string(),
    version: z.number().int(),
    mimeType: z.string(),
    size: z.number().int(),
    sha256: z.string(),
    uploadedAt: z.string().datetime(),
    uploadedById: z.string().nullable(),
    uploadedByName: z.string().nullable(),
});
// Estado de indexación RAG. Duplicado del enum de Prisma para no acoplarlos.
export const DocIndexStatusSchema = z.enum([
    'PENDING',
    'PROCESSING',
    'DONE',
    'FAILED',
    'SKIPPED',
]);
export const DocumentListItemSchema = z.object({
    id: z.string(),
    fileName: z.string(),
    category: DocumentCategorySchema,
    tags: z.array(z.string()),
    caseId: z.string().nullable(),
    clientId: z.string().nullable(),
    latestVersion: z.number().int(),
    latestSize: z.number().int(),
    latestMimeType: z.string(),
    versionsCount: z.number().int(),
    createdAt: z.string().datetime(),
    createdByName: z.string().nullable(),
    indexStatus: DocIndexStatusSchema,
});
export const DocumentDetailSchema = DocumentListItemSchema.extend({
    notes: z.string().nullable(),
    versions: z.array(DocumentVersionDtoSchema),
});
//# sourceMappingURL=documents.js.map